import { Box, BoxProps, Skeleton } from "@chakra-ui/react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";

const baseFragment = gql(/* GraphQL */ `
  fragment DistributionCenterBaseNameFragment on DistributionCenter {
    id
    name
  }
`);

const fragment = gql(/* GraphQL */ `
  fragment DistributionCenterNameFragment on DistributionCenter {
    id
    ...DistributionCenterBaseNameFragment
    orderingPlatform {
      id
      name
    }
  }
`);

type BaseProps = BoxProps & {
  isLoading?: boolean;
  distributionCenter: FragmentType<typeof baseFragment> | null | undefined;
};

export function BaseDistributionCenterName({
  isLoading,
  distributionCenter,
  ...rest
}: BaseProps) {
  const dc = getFragmentData(baseFragment, distributionCenter);

  const isDefault = dc?.name === null || dc?.name === "";

  return (
    <Box
      as="span"
      data-is-default={isDefault || undefined}
      sx={{ "&[data-is-default]": { opacity: 0.5 } }}
      noOfLines={2}
      {...rest}
    >
      <Skeleton as="span" isLoaded={!!dc?.name || !isLoading}>
        {isDefault ? "Default" : dc?.name || "                 "}
      </Skeleton>
    </Box>
  );
}

type Props = BoxProps & {
  isLoading?: boolean;
  distributionCenter: FragmentType<typeof fragment> | null | undefined;
};

export default function DistributionCenterName({
  isLoading,
  distributionCenter,
  ...rest
}: Props) {
  const dc = getFragmentData(fragment, distributionCenter);

  const op = dc?.orderingPlatform;

  return (
    <Box
      display="inline-flex"
      flexFlow="column"
      maxW="100%"
      lineHeight="normal"
      {...rest}
    >
      <Box
        fontSize=".8em"
        fontWeight="lighter"
        isTruncated
        opacity={0.75}
        mb=".25em"
      >
        <Skeleton isLoaded={!!op?.name || !isLoading} display="inline">
          {op?.name || "                              "}
        </Skeleton>
      </Box>

      <BaseDistributionCenterName
        isLoading={isLoading}
        distributionCenter={dc}
      />
    </Box>
  );
}
